export default __webpack_public_path__ + "static/media/21t.1b47bcf9.jpg";